import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import { areaCodesValidator, checkIsValidAreaCodes, checkIsValidAreaCodesRange } from "../utils";
import "./DestinationEdit.less";

interface ComponentProps {
  validatingAreaCodes: string;
  visible: boolean;
  closeModal: () => void;
  saveAreaCodes: (areaCodes: string) => void;
  onSubmitValidation?: boolean; // Если валидация по сохранении, добавляется проверка на то, чтобы диапазоне кодов, конечный был больше начального
}

export const AreaCodesValidateModal = (props: ComponentProps) => {
  const { validatingAreaCodes, saveAreaCodes, visible, closeModal, onSubmitValidation } = props;
  const [codes, setCodes] = useState<{ code: string; isValid: boolean }[]>([]);
  const [form] = Form.useForm<{ areaCodes: string }>();

  // Удаление пробелов и повторяющихся точек с запятой
  const deleteRepitedSigns = (value: string): string => {
    if (value.includes(";;")) {
      const cleanedValue = value.replace(";;", ";");
      return deleteRepitedSigns(cleanedValue);
    }
    if (value.includes(" ")) {
      const cleanedValue = value.replace(" ", "");
      return deleteRepitedSigns(cleanedValue);
    }
    return value;
  };

  const onChange = (value: string) => {
    const areaCodes = deleteRepitedSigns(value);
    setCodes(
      areaCodes
        .split(";")
        .filter(Boolean)
        .map((code) => {
          const endsWithDash = code.endsWith("-");
          const isValidRange = onSubmitValidation ? checkIsValidAreaCodesRange(code) : true;
          const isValid =
            Boolean(code) && checkIsValidAreaCodes(code) && !endsWithDash && isValidRange;
          return {
            code,
            isValid,
          };
        })
    );
    form.setFieldsValue({ areaCodes });
    form.validateFields(["areaCodes"]);
  };

  // Установка исходных значений
  useEffect(() => {
    onChange(validatingAreaCodes);
  }, [validatingAreaCodes]);

  const onSubmit = ({ areaCodes }) => {
    saveAreaCodes(areaCodes);
    closeModal();
  };

  const footer = [
    <Button key="1" onClick={closeModal} className="destination-edit-btn">
      Отмена
    </Button>,
    <Button type="primary" key="2" className="destination-edit-btn" onClick={form.submit}>
      Сохранить
    </Button>,
  ];

  const areaCodesValidatorOnSubmit = (x, value: string) => {
    const isValidRange = checkIsValidAreaCodesRange(value);
    if (isValidRange) {
      return Promise.resolve();
    }
    return Promise.reject();
  };

  return (
    <Modal
      visible={visible}
      footer={footer}
      title={<h2>Ошибка при валидации</h2>}
      className="destination-edit-validateModal"
      onCancel={closeModal}
      width="1200px"
    >
      <label>
        Результат валидации
        {onSubmitValidation && (
          <span style={{ color: "red" }}> (конечный код должен быть больше начального)</span>
        )}
      </label>
      <div className="destination-edit-validateModal__areaCodes">
        {codes.map(({ code, isValid }, idx) => (
          <div key={idx} style={{ color: isValid ? "inherit" : "red" }}>
            {code}
          </div>
        ))}
      </div>
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="areaCodes"
          label="Текущее значение"
          rules={[
            {
              validator: onSubmitValidation ? areaCodesValidatorOnSubmit : areaCodesValidator,
            },
          ]}
          className="form-item-required__hidden-error__mb0"
        >
          <Input onChange={(e) => onChange(e.target.value)} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
